import { TimeOffTypeCode } from '@/modules/common/types/time-off-type';
import { mapOpsiumUserShortFromDTO } from '@/modules/team/mappers/opsium-user-short.mapper';

import {
  ApprovalStatusDto,
  TimeOffRequestApproverResponse,
  TimeOffRequestListItemResponse,
  TimeOffTypeResponse,
} from '../types/dto/time-off-request.dto';
import {
  ApprovalStatus,
  DayPortion,
  TimeOffRequest,
  TimeOffRequestApprover,
} from '../types/time-off-request';

export const mapApprovalStatus = (status: ApprovalStatusDto): ApprovalStatus => {
  switch (status) {
    case ApprovalStatusDto.Approved:
      return ApprovalStatus.Approved;
    case ApprovalStatusDto.Rejected:
      return ApprovalStatus.Rejected;
    case ApprovalStatusDto.Pending:
    default:
      return ApprovalStatus.Pending;
  }
};

export const mapApprover = (approver: TimeOffRequestApproverResponse): TimeOffRequestApprover => ({
  user: mapOpsiumUserShortFromDTO(approver.user),
  status: mapApprovalStatus(approver.status),
  stepStatus: approver.stepStatus,
  decidedAt: approver.decidedAt,
  comment: approver.comment,
});

export const mapTimeOffType = (type: TimeOffTypeResponse) => {
  // Map the code string to TimeOffTypeCode enum if it matches a known value
  let code: TimeOffTypeCode | null = null;
  if (type.code && Object.values(TimeOffTypeCode).includes(type.code as TimeOffTypeCode)) {
    code = type.code as TimeOffTypeCode;
  }

  return {
    id: type.id,
    code,
    displayName: type.displayName,
  };
};

export const mapTimeOffRequestFromDTO = (
  response: TimeOffRequestListItemResponse
): TimeOffRequest => ({
  id: response.id,
  type: mapTimeOffType(response.type),
  status: response.status,
  startDate: response.startDate,
  endDate: response.endDate,
  totalDays: response.totalDays,
  days: response.days.map(day => ({
    date: day.date,
    partOfDay: day.partOfDay,
    portion: day.portion as unknown as DayPortion,
    minutes: day.minutes,
  })),
  partOfDay: response.partOfDay,
  approvers: response.approvers.map(mapApprover),
  requestedBy: mapOpsiumUserShortFromDTO(response.requestedBy),
  timeCategory: response.timeCategory,
  description: response.description,
  allowedActions: response.allowedActions,
  requestedAt: response.requestedAt,
  approvedAt: response.approvedAt,
});
